import { useTranslation } from 'react-i18next'

import {
  Avatar,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@maxus/website/components'
import { useAuth, useLogout } from '@maxus/website/hooks'

export const User = () => {
  const { t } = useTranslation()

  const { user } = useAuth()
  const { confirmLogout } = useLogout()

  const bizUser = user?.activeBizUser ?? null
  const name = bizUser?.name ?? ''
  const avatarUrl = bizUser?.avatarUrl ?? null
  const initial = (name.trim()[0] ?? '?').toUpperCase()

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button aria-label={t('Log out')} className="mt-auto mb-7 rounded-full" onClick={confirmLogout} type="button">
          <Avatar
            avatarUrl={avatarUrl}
            name={initial}
            classNames={{
              root: 'size-8 ring-2 ring-border-strong',
              fallback: 'bg-surface-active text-xs text-text-primary',
            }}
          />
        </button>
      </TooltipTrigger>
      <TooltipContent side="right">{t('Log out')}</TooltipContent>
    </Tooltip>
  )
}
